<div>
	<h3>{{ (selectedOption === 'local' ? 'ACTION_HISTORY' : 'SAVE_HISTORY') | translate }}</h3>
	<div class="states" *ngIf="stateHistory && selectedOption === 'local'">
		<div class="version-item" [class.active]="state === activeState"
			*ngFor="let state of stateHistory; let i = index;"
			(click)="goToState('GOTOSTATE', state)">
				<span>{{ state.fromCommand | translate }}</span>
				<span [innerHTML]="state.dateTime | bbDate:'relative'" [title]="state.dateTime | bbDate"></span>
		</div>
	</div>

	
	<div class="versions" *ngIf="entityVersions && selectedOption !== 'local'" #scrollDiv (ngInit)="setScrollDiv(scrollDiv)">
		<!-- <h3>Versions</h3>
		<div>
			Current version state: {{ currentVersionState }}
		</div>
		<div>
			<label *ngIf="entityConfiguration?.versionMetadataToSave">
				{{'SET_VERSIONSTATE' | translate}} <br />
				<input [(ngModel)]="vs" type="text" name="versionState" (change)="onVersionStateChange(vs)" />
			</label>
		</div>
		<div>
			<label *ngIf="entityConfiguration?.versionMetadataToSave">
				{{'VERSION_COMMENT' | translate}} <br />
				<input [(ngModel)]="entityConfiguration.versionMetadataToSave.bbcomment" type="text" name="versionComment" />
			</label>
		</div> -->
		<div *ngIf="!entityVersions?.length && !loading">
			{{ 'NO_SAVED_VERSIONS' | translate }}
		</div>
		<div *ngIf="loading">
			{{ 'LOADING' | translate }}...
		</div>
		<div class="version-item"
			*ngFor="let version of entityVersions"
			(click)="onVersionClick(version)"
			[title]="(version.date | date) + ' ' + (version.date | date:'shortTime')"
			[class.active]="entityDetails?.activeVersion && entityDetails?.activeVersion?.id === version.id">
			<!-- <span *ngIf="version.isLatest">(latest)</span> -->
			<div [title]="version.date | bbDate">
				<i class="active-marker fa fa-angle-right"></i>
				{{ version.date | bbDate:'relative' }}
			</div>
			<div *ngIf="version?.metadata">
				<span *ngIf="version?.metadata?.alsopublished === 'true'" [title]="'THIS_VERSION_WAS_ALSO_PUBLISHED' | translate">
					<i class="fa fa-check"></i>
				</span>
				<span *ngIf="version?.metadata?.comment" [title]="('COMMENT' | translate) + ': ' + version.metadata.comment">
					<i class="fa fa-comment"></i>
				</span>
				<span *ngIf="version?.metadata?.author">
					{{ version.metadata.author }}
				</span>
				<a
					*ngIf="selectedOption !== 'local' && locationService?.server && entityDetails?.entity?.parentEntityId"
					(click)="$event.stopPropagation()"
					[title]="'PREVIEW_IN_PLAYER' | translate"
					target="_blank"
					[href]="locationService?.server + '/p/default/' + 
					(entityDetails?.entity?.parentEntityType === 'Project' ? 'p' : 'c') + '/' +
					(entityDetails?.entity?.parentEntityType === 'App' ? 'ovp2575390' : entityDetails?.entity?.parentEntityId ) +
					'.html?inheritDimensions=true&fitmode=FIT_BOTH&useSapi=true&useSession=true&noStats=true&state=' + selectedOption +
					'&timelineVersion=' + version.id +
					(entityDetails?.entity?.parentEntityType === 'App' ? '&timelineId=' + entityDetails?.entity?.id : '')"
					style="margin: 0 10px;"
				>
					<i class="fa fa-play-circle"></i>
				</a>
			</div>
		</div>
	</div>

	<div class="filter-buttons">
		<ng-container *ngFor="let option of selectionOptions">
			<bb-button
				*ngIf="theme === 'light'"
				[active]="selectedOption === option.value"
				(click)="onFilterClick(option)"
			>{{ option?.label }}</bb-button>
			<div
				*ngIf="theme === 'dark'"
				(click)="onFilterClick(option)"
				class="filter-button"
				[class.active]="selectedOption === option.value"
			>
				<span class="value">
					{{ option?.label }}
				</span>
			</div>
		</ng-container>
	</div>
</div>
